"use client";

import { legacyIconCls } from "@faire/web/slate/utils/tracking";
import React from "react";

import { createSVGIcon } from "../util";

/**
 * @deprecated use TrashCan from foundation/TrashCan
 * @trackcomponent
 * @optimized using svgo:^3.0.2
 */
export const Trash = createSVGIcon(
  <path
    d="M4.286 7.5h15.428M6.214 7.5h11.571v11.571a1.286 1.286 0 0 1-1.285 1.286h-9a1.286 1.286 0 0 1-1.286-1.286zM8.786 7.5v-.643a3.214 3.214 0 0 1 6.428 0V7.5M10.071 10.071v7.072M13.929 10.071v7.072"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
  />,
  "Trash",
  { viewBox: "0 0 24 24", fill: "none", className: legacyIconCls() }
);
